import * as server from '../entries/pages/admin/users/_id_integer_/_page.server.ts.js';

export const index = 38;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/users/_id_integer_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/admin/users/[id=integer]/+page.server.ts";
export const imports = ["_app/immutable/nodes/38.DX4CRaYN.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/_bkH3ryn.js","_app/immutable/chunks/Bu9wkQ5s.js","_app/immutable/chunks/B764PkgB.js","_app/immutable/chunks/BRzKQYUk.js"];
export const stylesheets = [];
export const fonts = [];
